import { render, staticRenderFns } from "./VSwitchButton.vue?vue&type=template&id=08e78652&scoped=true&"
import script from "./VSwitchButton.vue?vue&type=script&lang=ts&"
export * from "./VSwitchButton.vue?vue&type=script&lang=ts&"
import style0 from "./VSwitchButton.vue?vue&type=style&index=0&id=08e78652&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e78652",
  null
  
)

export default component.exports